
import ServiceDetailLayout from '../../../components/feature/ServiceDetailLayout';

export default function RehabilitationOutreachPage() {
  return (
    <ServiceDetailLayout
      heroTitle="專業復康外展服務"
      heroSubtitle="為院舍提供全方位專業復康治療團隊，協助長者重拾生活能力"
      heroImage="https://public.readdy.ai/ai/img_res/6ef9582846e1e165351aac596472a662.jpg"
      breadcrumbs={[
        { name: '首頁', href: '/' },
        { name: '服務項目', href: '/#services' },
        { name: '專業復康外展服務', href: '/services/rehabilitation-outreach' },
      ]}
      overviewTitle="專業復康外展服務"
      overviewDescription="康顧提供專業註冊治療師團隊，為院舍長者提供物理治療、職業治療及言語治療服務。我們的治療師均具備豐富的院舍服務經驗，能夠因應不同長者的需要，制定個人化的復康訓練計劃，協助院舍提升整體照護質素。"
      overviewImage="https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20occupational%20therapist%20working%20with%20elderly%20patient%20doing%20hand%20exercises%20in%20bright%20nursing%20home%2C%20warm%20caring%20interaction%2C%20therapy%20tools%20on%20table%2C%20professional%20medical%20setting%2C%20natural%20daylight%2C%20clean%20simple%20background&width=800&height=600&seq=rehab-overview-001&orientation=landscape"
      overviewHighlights={[
        '所有治療師均為香港註冊專業人員',
        '豐富的院舍服務經驗，熟悉長者需要',
        '提供個人化評估及訓練計劃',
        '定期進度報告及家屬溝通',
        '靈活排期配合院舍運作',
        '協助申請政府資助計劃',
      ]}
      serviceDetails={[
        {
          icon: 'ri-heart-pulse-line',
          name: '物理治療服務',
          description: '由註冊物理治療師提供專業評估及治療，針對長者的肌肉骨骼問題、活動能力及平衡訓練。',
          features: [
            '肌肉骨骼評估及治療',
            '步態訓練及平衡改善',
            '痛症管理及舒緩',
            '關節活動度訓練',
            '預防跌倒訓練計劃',
            '使用輔助器具指導',
          ],
        },
        {
          icon: 'ri-hand-heart-line',
          name: '職業治療服務',
          description: '註冊職業治療師協助長者維持及改善日常生活能力，提升自理能力及生活質素。',
          features: [
            '日常生活能力評估',
            '認知功能訓練',
            '手部功能訓練',
            '感官刺激活動',
            '環境改善建議',
            '輔助工具評估及訓練',
          ],
        },
        {
          icon: 'ri-chat-voice-line',
          name: '言語治療服務',
          description: '註冊言語治療師處理長者的吞嚥困難及溝通障礙問題，確保安全進食及有效溝通。',
          features: [
            '吞嚥功能評估及訓練',
            '進食姿勢及技巧指導',
            '餐單質地建議',
            '語言及溝通能力評估',
            '發音及表達訓練',
            '認知溝通訓練',
          ],
        },
      ]}
      pricingTitle="服務收費方案"
      pricingPlans={[
        {
          name: '基本計劃',
          price: 'HK$800',
          note: '每節 · 適合小型院舍或初次使用',
          features: [
            '每節 45 分鐘',
            '單一治療項目',
            '基本評估報告',
            '每月進度更新',
            '電話查詢支援',
          ],
          highlighted: false,
        },
        {
          name: '標準計劃',
          price: 'HK$6,500',
          note: '每月 · 最受歡迎，適合中型院舍',
          features: [
            '每週 2 節治療',
            '可選擇不同治療項目',
            '詳細評估及訓練計劃',
            '每月書面進度報告',
            '家屬溝通會議',
            '優先預約時段',
          ],
          highlighted: true,
        },
        {
          name: '全面計劃',
          price: '面議',
          note: '適合大型院舍或特殊需要',
          features: [
            '度身訂造服務方案',
            '多專業團隊協作',
            '駐場治療師服務',
            '員工培訓工作坊',
            '24/7 緊急諮詢',
            '政府資助申請協助',
          ],
          highlighted: false,
        },
      ]}
      faqs={[
        {
          question: '治療師的資歷如何？',
          answer: '我們所有治療師均為香港註冊專業人員，持有相關學位及執業證書，並具備最少 3 年以上的院舍服務經驗。團隊定期參與持續專業進修，確保服務質素。',
        },
        {
          question: '如何安排治療時間？',
          answer: '我們會與院舍協調，安排最適合的治療時段。一般建議在長者精神狀態較佳的上午或下午時段進行。我們提供靈活排期，可配合院舍的日常運作及活動安排。',
        },
        {
          question: '需要準備什麼設施或器材？',
          answer: '基本治療只需要一個安靜、光線充足的空間及椅子即可。如需特別器材，我們的治療師會自備專業設備。我們也可以就院舍現有設施提供改善建議。',
        },
        {
          question: '可以申請政府資助嗎？',
          answer: '可以。符合資格的院舍可申請「改善買位計劃」、「私營殘疾人士院舍買位計劃」等資助。我們的團隊熟悉申請流程，可提供專業意見及協助準備所需文件。',
        },
        {
          question: '如何評估治療成效？',
          answer: '每位長者在開始治療前會進行詳細評估，制定個人化目標。治療師會定期進行進度評估，並提供書面報告。我們也會安排家屬會議，讓家屬了解長者的進展情況。',
        },
        {
          question: '最少需要簽約多久？',
          answer: '我們建議最少 3 個月的服務期，以確保治療效果。但我們也提供靈活的合約安排，可按院舍需要調整服務內容及頻率。',
        },
      ]}
      ctaTitle="立即預約免費諮詢"
      ctaDescription="我們的專業團隊將為您的院舍度身訂造最合適的復康服務方案，歡迎聯絡我們了解更多。"
    />
  );
}
